module.exports = __webpack_public_path__ + "img/logo-gray-quickbooks.f53a2af4.png";